import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const FiltersPanel = ({ filters, setFilters, onClose }) => {
  const times = [
    { value: 'any', label: 'Cualquier hora' },
    { value: 'morning', label: 'Mañana (hasta 14:00)' },
    { value: 'afternoon', label: 'Tarde (14:00-19:00)' },
    { value: 'evening', label: 'Noche (desde 19:00)' }
  ];

  const versions = [
    { value: 'all', label: 'Todas las versiones' },
    { value: 'dubbed', label: 'Doblada al castellano' },
    { value: 'subtitled', label: 'Versión original con subtítulos en castellano' }
  ];

  const handleTimeChange = (value) => {
    setFilters({ ...filters, time: value });
  };

  const handleVersionChange = (value) => {
    setFilters({ ...filters, version: value });
  };

  const clearFilters = () => {
    setFilters({ time: 'any', version: 'all' });
  };

  return (
    <div className="bg-[#2e4a2a] p-6 border-b border-[#50c878]/20">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-[#f5f5dc]">Filtros</h3>
          <button onClick={onClose} className="text-[#f5f5dc]/40 hover:text-[#f5f5dc] transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Time Filter */}
          <div>
            <label className="block text-sm font-medium text-[#50c878] mb-3">Horario</label>
            <div className="space-y-3">
              {times.map((time) => (
                <label key={time.value} className="flex items-center gap-3 cursor-pointer group">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
                    filters.time === time.value 
                      ? 'border-[#50c878] bg-[#50c878]' 
                      : 'border-[#50c878]/40 group-hover:border-[#50c878]'
                  }`}>
                    {filters.time === time.value && (
                      <div className="w-2 h-2 rounded-full bg-white" />
                    )}
                  </div>
                  <span className="text-sm text-[#f5f5dc]/80 group-hover:text-[#f5f5dc]">{time.label}</span>
                </label>
              ))}
            </div>
          </div>
          
          {/* Version Filter */}
          <div>
            <label className="block text-sm font-medium text-[#50c878] mb-3">Versión</label>
            <div className="space-y-3">
              {versions.map((version) => (
                <label key={version.value} className="flex items-center gap-3 cursor-pointer group">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
                    filters.version === version.value 
                      ? 'border-[#50c878] bg-[#50c878]' 
                      : 'border-[#50c878]/40 group-hover:border-[#50c878]'
                  }`}>
                    {filters.version === version.value && (
                      <div className="w-2 h-2 rounded-full bg-white" />
                    )}
                  </div>
                  <span className="text-sm text-[#f5f5dc]/80 group-hover:text-[#f5f5dc]">{version.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
        
        <div className="flex items-center justify-end gap-4 mt-8 pt-6 border-t border-[#50c878]/20">
          <Button 
            variant="outline" 
            onClick={clearFilters} 
            className="border-[#50c878]/40 text-[#f5f5dc]/60 hover:text-[#f5f5dc] hover:bg-[#50c878]/10 hover:border-[#50c878]"
          >
            Limpiar filtros
          </Button>
          <Button 
            onClick={onClose} 
            className="bg-[#50c878] hover:bg-[#40a0a0] text-white"
          >
            Ver pases
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FiltersPanel;
